import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDayPrimaryThree = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

LaborDayPrimaryThree.palette['--sui-palette-background-primary'] = '242 172 62';

export { LaborDayPrimaryThree };
